import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-bg-warning p-3 fw-700"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row apb-number-row" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = {
  key: 0,
  class: "row row-symbol"
}
const _hoisted_6 = { class: "row row-position" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_9 = { class: "alert alert-warning fw-700 mb-3 d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mas me-2 fs-5" }, "warning", -1)
const _hoisted_11 = { class: "row row-cols-4 mb-4" }
const _hoisted_12 = { class: "row row-settings" }
const _hoisted_13 = { class: "col-1" }
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "row row-settings" }
const _hoisted_17 = { class: "col-1" }
const _hoisted_18 = { class: "col-1" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "row row-settings" }
const _hoisted_21 = { class: "col-1" }
const _hoisted_22 = { class: "col-1" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "row row-settings" }
const _hoisted_25 = { class: "col-1" }
const _hoisted_26 = { class: "col-1" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "row row-settings" }
const _hoisted_29 = { class: "col-1" }
const _hoisted_30 = { class: "col-1" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "row row-settings" }
const _hoisted_33 = { class: "col-1" }
const _hoisted_34 = { class: "col-1" }
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "row row-settings mb-4 mt-4" }
const _hoisted_37 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_input_checkbox = _resolveComponent("input-checkbox")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !this.isReady
    }, null, 8, ["spin"]),
    (!this.isNvpAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('salvusMissingSettings')), 1))
      : _createCommentVNode("", true),
    (this.isReady && this.isNvpAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputSelect, {
                name: "selectedSalvusAuthentication",
                label: "Kies apb nummer",
                modelValue: this.contentBlock.apb_number,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((this.contentBlock.apb_number) = $event)),
                  _ctx.onSalvusApbNumberChanged
                ],
                options: _ctx.apbNumberOptionsMap,
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "errors"])
            ])
          ]),
          (this.activeSalvusAuthentication !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_InputSelect, {
                      modelValue: this.contentBlock.appointment_types_to_show_code,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.contentBlock.appointment_types_to_show_code) = $event)),
                      options: this.appointmentTypeOptions,
                      name: _ctx.$t('cms.salvus_appointmentTypesToShow'),
                      selectText: _ctx.$t('cms.salvus_appointmentTypesToShow'),
                      label: _ctx.$t('cms.salvus_appointmentTypesToShow'),
                      rules: "required",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "options", "name", "selectText", "label", "errors"])
                  ])
                ]),
                (Object.keys(this.salvusAppointmentIds).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('cms.salvus_noAppointmentIdentifiers')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (this.contentBlock.appointment_types_to_show_code === _ctx.SalvusAppointmentTypesToShowEnum.SPECIFIED)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_Subtitle, {
                        title: _ctx.$t('cms.salvus_appointmentIdentifiers'),
                        mb: "3"
                      }, null, 8, ["title"]),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.salvusAppointmentConfigurations, (config, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col",
                            key: i
                          }, [
                            _createVNode(_component_input_checkbox, {
                              errors: _ctx.errors,
                              name: 'appointment_config_' + i,
                              modelValue: this.salvusAppointmentIds[config.id],
                              "onUpdate:modelValue": [($event: any) => ((this.salvusAppointmentIds[config.id]) = $event), _ctx.onChange],
                              label: config.title
                            }, null, 8, ["errors", "name", "modelValue", "onUpdate:modelValue", "label"])
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_Subtitle, {
                  title: _ctx.$t('formFields'),
                  mb: "3"
                }, null, 8, ["title"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('request')), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('required')), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('field')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_visible_email,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((this.contentBlock.is_field_visible_email) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_visible_email",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_required_email,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((this.contentBlock.is_field_required_email) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_required_email",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('cms.salvus_field_email')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_visible_phone,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((this.contentBlock.is_field_visible_phone) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_visible_phone",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_required_phone,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((this.contentBlock.is_field_required_phone) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_required_phone",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('cms.salvus_field_phone')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_visible_postal_code,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((this.contentBlock.is_field_visible_postal_code) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_visible_postal_code",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_required_postal_code,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => ((this.contentBlock.is_field_required_postal_code) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_required_postal_code",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('cms.salvus_field_postal_code')), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_visible_dob,
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => ((this.contentBlock.is_field_visible_dob) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_visible_dob",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_required_dob,
                      "onUpdate:modelValue": [
                        _cache[9] || (_cache[9] = ($event: any) => ((this.contentBlock.is_field_required_dob) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_required_dob",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('cms.salvus_field_dob')), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_visible_gender,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((this.contentBlock.is_field_visible_gender) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_visible_gender",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_field_required_gender,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => ((this.contentBlock.is_field_required_gender) = $event)),
                        this.onChange
                      ],
                      name: "salvus_is_field_required_gender",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('cms.salvus_field_gender')), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: this.contentBlock.is_consent_required,
                      "onUpdate:modelValue": [
                        _cache[12] || (_cache[12] = ($event: any) => ((this.contentBlock.is_consent_required) = $event)),
                        this.onChange
                      ],
                      label: _ctx.$t('cms.salvus_is_consent_required'),
                      name: "salvus_is_consent_required",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}